export const MenuMixin = {
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    onMouseDown(event) {
      let el = event.target
      let closeDialog = true

      while (el !== null && el.nodeType === 1) {
        if (el.className.indexOf('dialog') !== -1) {
          closeDialog = false
          break
        }
        el = el.parentElement || el.parentNode
      }

      if (closeDialog) {
        this.hideDialog()
      }
    },
    showDialog() {
      this.dialogVisible = true
      document.addEventListener('mousedown', this.onMouseDown, { passive: true })
    },
    hideDialog(event) {
      this.dialogVisible = false
      document.removeEventListener('mousedown', this.onMouseDown)
    }
  }
}
